import React from 'react'

class ContentHtml extends React.Component {
  render() {
    var
      html,
      _ = require('lodash')

    try {
      html = _.template(_.get(this.props, 'layout.settings.html'))({ data: _.get(this.props, 'data.contentData') })
    } catch (e) {
      html = `<div class="html-error">${e}</div>`
      console.error(e)
    }

    return (
      <div className="content-html">
        <style>
          { _.get(this.props, 'layout.settings.css') }
        </style>
        <div
          ref={ el => this.el = el }
          dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    )
  }

  componentDidMount() {
    /* eslint-disable */
    var
      _ = require('lodash'),
      data = this.props.data.contentData,
      entries = _.map(data, d => d.gist),
      el = this.el
    eval(_.get(this.props, 'layout.settings.js'))
    /* eslint-enable */
  }
}

export default ContentHtml